/* eslint-disable import/prefer-default-export */
const FETCH_ZONES = 'app/ZONE/FETCH_ZONES';
const SET_ZONES = 'app/ZONE/SET_ZONES';
const FETCH_FIELDS = 'app/ZONE/FETCH_FIELDS';
const SET_FIELDS = 'app/ZONE/SET_FIELDS';
const SAVE_ZONE_UPDATE = 'app/ZONE/SAVE_ZONE_UPDATE';
const UPDATE_ZONE = 'app/ZONE/UPDATE_ZONE';
const QUICK_RUN = 'app/ZONE/QUICK_RUN';
const MULTIPLE_QUICK_RUN = 'app/ZONE/MULTIPLE_QUICK_RUN';
const SET_ZONE_IMAGES = 'app/ZONE/SET_ZONE_IMAGES';

export {
  FETCH_ZONES,
  SET_ZONES,
  FETCH_FIELDS,
  SET_FIELDS,
  UPDATE_ZONE,
  SAVE_ZONE_UPDATE,
  QUICK_RUN,
  MULTIPLE_QUICK_RUN,
  SET_ZONE_IMAGES,
};
